<template>
    <v-card
            flat
            v-if="content.terms_of_use !=null"
    >
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container
                v-for="(i, index) in content" :key="index"
                container--fluid
                class="term-of-use signup-container"
        >

            <v-layout>
                <v-flex xs12>
                    <!-- Title -->
                    <!-- <v-card-text class="tab-title"><h4 class="text-color">Terms of Service</h4></v-card-text> -->
                    <v-card-text class="tab-title">
                        <h2 class="title mr-3">Terms of Service</h2> 
                        <em class="body-2 grey--text">Last updated {{ dateFormat(i.updated_at) }}</em>
                    </v-card-text>
                    <!-- Editor -->
                    <vue-editor ref="myTextEditor"
                                  v-model="i.content"
                                  :editorToolbar="customToolbar"
                                  class="quill-editor-tabs">
                    </vue-editor>
                    <!-- Buttons -->
                    <v-btn
                            :color="savedButton.color"
                            class="btns-onboard"
                            type="submit"
                            @click.native="postContent(i.content)"
                            :loading="savedButton.loading"
                            :disabled="savedButton.loading"
                            transition="fade-transition">
                        {{savedButton.text}}
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
    <v-card flat v-else>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container v-if="loading == false" class="onboarding-error-message">
            <h1>!</h1><h5>Something went wrong!</h5><h5>Please refresh your browser and try again.</h5>
        </v-container>
    </v-card>
</template>

<script>
    import {VueEditor} from 'vue2-quill-editor';
    import ApiService from "../../../common/api.service";

    export default {
        props: ['orgid'],
        components: {
            VueEditor
        },
        data() {
            return {
                content: [],
                customToolbar: [
                    ['bold', 'italic', 'underline', 'link'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
                loading: true,
                savedButton: {
                    color: "cyan darken-3",
                    text: 'Save Changes',
                    loading: false
                },
            }
        },
        beforeMount() {
            this.getContent()
        },

        methods: {
            getContent() {
                ApiService.get(`/client_on_boarding_setup/terms_of_use/${this.orgid}`)
                    .then(response => {
                        let data = response.data;
                        this.content = data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            postContent(content) {
                this.savedButton.loading = true;
                let data = {
                    organization_form_id: this.orgid,
                    content: content,
                };
                ApiService.put(`/client_on_boarding_setup/terms_of_use`, data)
                    .then(response => {
                        this.getContent()
                        this.savedButton = {
                            color: 'success',
                            text: 'Changes Saved',
                            loading: false
                        }
                        setTimeout(() => {
                            this.savedButton = {
                                color: "cyan darken-3",
                                text: 'Save Changes',
                                loading: false
                            }
                        }, 3000);
                    })
                    .catch(error => {
                        this.savedButton = {
                            color: "red",
                            text: 'Save Unsuccessful',
                            loading: false
                        }
                        setTimeout(() => {
                            this.savedButton = {
                                color: "cyan darken-3",
                                text: 'Save Changes',
                                loading: false
                            }
                        }, 5000);
                    });
            },
            dateFormat (i) {
                return moment(i).format('YYYY/MM/DD')
            }
        }
    }
</script>
